(ns rothko.theme.manatee.editor.tag
  (:require [garden.color :refer [lighten rgb rgba]]
            [rothko.theme.manatee.editor.common :as common-theme]
            [rothko.theme.manatee.colours :refer [colours]]))

(def main
  (merge
   common-theme/different
   {:immutable
    {:background-color (rgba 0 120 0 0.15)
     :color (rgb 0 120 0)
     :outline (str "1px dotted rgba(0,120,0,0.50)")}

    :previous-stage
    {:background-color (rgba 0 0 120 0.15)
     :color (rgb 0 0 120)
     :outline (str "1px dotted rgba(0,0,120,0.50)")}

    :system
    {:background-color (lighten (:blue-light colours) 40)
     :color (:blue-light colours)
     :outline [["1px" "dotted" (:blue-light colours)]]}

    :edited
    {:color (rgb 120 0 0)
     :text-decoration :line-through}}))
